/**
 * ToastMessagePanel constructor
 * @param {HTMLElement} element
 * @constructor
 */
import { MessageBus } from '@/service/message-bus';
import { translate } from '@/filters';
import { Util } from '@/util/util';

export class ToastMessagePanel {
  private element: HTMLElement;
  private currentTimeOut: number | null;

  constructor(element: HTMLElement) {
    this.element = element;
    this.element.classList.remove('expanded');
    this.currentTimeOut = null;
  }

  /**
   * Method which shows a toast message within the toast panel.
   * @param {string} message
   * @param {boolean} isShoppingCart
   * @param {string} extraMessage
   */
  showMessage(message: string, isShoppingCart: boolean = false, extraMessage: string = '') {
    const me = this;

    if (me.currentTimeOut !== null) {
      clearTimeout(me.currentTimeOut);
      me.element.classList.remove('expanded');
      me.currentTimeOut = null;
    }

    if (isShoppingCart) {
      me.element.innerHTML = `
        <p class="toast-panel-message">${message}</p>
        <span class="toast-panel-extra-message">${extraMessage}</span>
        <div class="toast-panel-buttons">
          <a href="${Util.getConfig().links.shoppingCartPage}" class="btn yellow toast-panel-buttons__btn toast-panel-link">
            ${translate('toastMessage.shoppingCart.toShoppingCart')}
          </a>
          <button
            onclick="this.parentElement.parentElement.classList.remove('expanded'); this.parentElement.parentElement.innerHTML = '';"
            class="toast-panel-buttons__btn toast-panel-close">
              ${translate('toastMessage.shoppingCart.close')}
          </button>
      </div>`;
    } else {
      me.element.innerHTML = `<p class="toast-panel-message">${message}</p>`;
    }

    setTimeout(function() {
      me.element.classList.add('expanded');
    }, 0);

    me.currentTimeOut = setTimeout(function() {
      me.element.classList.remove('expanded');
      while (me.element.lastElementChild) {
        me.element.removeChild(me.element.lastElementChild);
      }
      me.currentTimeOut = null;
    }, 6000);
  }
}
